// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2E6gN","newExpiryDate":"styles_newExpiryDate__3OBAr","footer":"styles_footer__2VCB3"};